import { currentUserQuery } from "@common/api/users"
import { hasPermission } from "@common/lib/permissions"
import type { QueryClient } from "@tanstack/react-query"
import { redirect } from "@tanstack/react-router"

export async function requirePermission(
  queryClient: QueryClient,
  permission: string,
  to: "/" | "/settings/workspace/general",
): Promise<void> {
  const user = await queryClient.ensureQueryData(currentUserQuery())
  if (!hasPermission(user, permission)) {
    throw redirect({ to })
  }
}
